import { collection, getDocs, addDoc, deleteDoc, updateDoc, doc } from 'firebase/firestore';
import { db } from '../firebase';
import { LinkSection, LinkItem } from '../types/familyLinks';
import { fetchLinksFromGoogleSheets } from './googleSheets';

const COLLECTION = 'familyLinks';

export async function fetchFamilyLinksFromFirestore(): Promise<LinkSection[]> {
  const snapshot = await getDocs(collection(db, COLLECTION));
  const linksMap: Record<string, LinkItem[]> = {};

  snapshot.forEach(docSnap => {
    const data = docSnap.data();
    const category = data.category as string;
    if (!linksMap[category]) linksMap[category] = [];
    linksMap[category].push({ id: docSnap.id, name: data.name, url: data.url });
  });

  return Object.entries(linksMap).map(([title, links]) => ({ title, links }));
}

export async function addFamilyLink(name: string, url: string, category: string): Promise<void> {
  await addDoc(collection(db, COLLECTION), { name, url, category });
}

export async function deleteFamilyLink(id: string): Promise<void> {
  await deleteDoc(doc(db, COLLECTION, id));
}

export async function updateFamilyLink(
  id: string,
  data: { name: string; url: string; category: string }
): Promise<void> {
  await updateDoc(doc(db, COLLECTION, id), data);
}

export async function seedFamilyLinksFromSheets(): Promise<LinkSection[]> {
  const sections = await fetchLinksFromGoogleSheets();
  const col = collection(db, COLLECTION);

  for (const section of sections) {
    for (const link of section.links) {
      await addDoc(col, { name: link.name, url: link.url, category: section.title });
    }
  }

  return fetchFamilyLinksFromFirestore();
}
